/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { TruncateText } from '@/components/ui'

type AssetTableCellProps = {
  tooltip?: string
  children: React.ReactNode
}

const AssetTableCell: React.FC<AssetTableCellProps> = ({ children, tooltip }) => {
  const isPrimitive = typeof children === 'string' || typeof children === 'number'
  return (
    // Full height so the tooltip covers the whole cell, with the value centred in it like the
    // asset name; the inner min-w-0 lets long text truncate rather than widen the column.
    <div className="flex h-full w-full items-center" {...(tooltip ? { title: tooltip } : {})}>
      <div className="w-full min-w-0">
        {isPrimitive ? (
          <TruncateText
            wrapperType="truncate"
            tooltipPosition="top"
            tooltipText={String(children)}
            renderItem={() => <>{children}</>}
          />
        ) : (
          children
        )}
      </div>
    </div>
  )
}

export default AssetTableCell
